import { PluginCard, PluginCardCommonProps } from '../../../plugins-tab/PluginCard';
import { PluginMeddicSvg } from '../../icons';
import { meddicTexts } from './texts';

export const MeddicPluginCard = (props: PluginCardCommonProps) => {
  return (
    <PluginCard
      svgIcon={<PluginMeddicSvg />}
      title={meddicTexts.title}
      description={meddicTexts.description}
      {...props}
    />
  );
};
